import React, { useState, useEffect } from "react";
import { NAMEPSACE } from "../Globals";
import './recommend.css';

export default function Recommend({ imdb_id, kino_rating, toggleRecommend, onRatingSaved }) {

  const [rating, setRating] = useState(kino_rating || 0);

    useEffect(() => {
        setRating(Number(kino_rating) || 0);
    }, [imdb_id, kino_rating]);

    const stopPropagation = (e) => {
        e.stopPropagation();
    }

    // Authentication is gated upstream (Buttons/Skin)

    const handleStarMouseDown = (value) => (e) => {
        e.preventDefault();
        e.stopPropagation();

        setRating(value);
    };

    const _onSubmit = async () => {
        const url = NAMEPSACE + "rating/kino";
        const payload = {
          imdb_id: imdb_id,
          rating: Number(rating), // 0–5
        };
      
        try {
          const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
          await res.json();
          if (typeof onRatingSaved === 'function') {
            onRatingSaved(Number(rating));
          }
          toggleRecommend();
        } catch (err) {
          console.error("Failed to save rating:", err);
        }
      };

    return (
        <div className="recommend">
            <div className={"row"}>
                <div className={"col-4 pr-4"}></div>
                <div className={"col-4"}>
                    <div className={"col-12 recommend-inner"}>
                        <div className="recommend-stars-row" onClick={stopPropagation}>
                            <button className="btn-circular main-buttons button-icon d-flex align-items-center"
                                    onMouseDown={handleStarMouseDown(1)}><i className="material-icons">{rating >= 1 ? "star" : "star_outline"}</i>
                            </button>
                            <button className="btn-circular main-buttons button-icon d-flex align-items-center"
                                     onMouseDown={handleStarMouseDown(2)}><i className="material-icons">{rating >= 2 ? "star" : "star_outline"}</i>
                            </button>
                            <button className="btn-circular main-buttons button-icon d-flex align-items-center"
                                     onMouseDown={handleStarMouseDown(3)}><i className="material-icons">{rating >= 3 ? "star" : "star_outline"}</i>
                            </button>
                            <button className="btn-circular main-buttons button-icon d-flex align-items-center"
                                     onMouseDown={handleStarMouseDown(4)}><i className="material-icons">{rating >= 4 ? "star" : "star_outline"}</i>
                            </button>
                            <button className="btn-circular main-buttons button-icon d-flex align-items-center"
                                     onMouseDown={handleStarMouseDown(5)}><i className="material-icons">{rating >= 5 ? "star" : "star_outline"}</i>
                            </button>
                        </div>
                        <div className={"recommend-submit-container"} onMouseDown={stopPropagation} onClick={stopPropagation}>
                            <p className={"recommend-submit"} onClick={_onSubmit}>SUBMIT</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
